import React, { useState, useEffect } from "react";

import Form from "deltoid/core/Form";
import { Row, Col } from "deltoid/core/Blocks/BootstrapContainers";
import { H, Small } from "deltoid/core/Blocks/Typography";
import Timer from '../timer';

const VerifyOTP = ({
  handleVerifyOTP,
  resendOtp,
  errMsg: errMsgProp,
  retryTime,
  onTimerComplete,
  disableResend,
  otpLength,
  disableVerifyBtn,
  mobile,
  email,
  onBack,
  isMFAEnabled=false,
}) => {

  const [errMsg, setErrMsg] = useState(errMsgProp);  
  const [otpValue, setOtpValue] = useState(null);

  useEffect(() => { setErrMsg(errMsgProp) }, [errMsgProp]);

  return (
    <Row noGutters>
      <Col className="pl-3 pr-3">
        <H level={5} variant="regular" className="co-heading worksansregular-font">
          {isMFAEnabled ? 'Two-Step Verification' : 'OTP Verification'}
        </H>
        <div className="co-bg-blue-tint p-3  mb-3">
          <Small>We have sent an OTP to your registered {mobile ? 'mobile number' : 'email'} </Small>
        </div>
        {mobile && <Form.Group className="position-relative mb-3">
          <Form.Label id="mobile">
            Mobile
          </Form.Label>
            <Form.Text
              id="mobile"
              name="mobile"
              type="text"
              defaultValue={"+91" + mobile}
              readOnly
            />
        </Form.Group>}
        {email && <Form.Group className="position-relative mb-3">
          <Form.Label id="email">
            Email
          </Form.Label>
            <Form.Text
              id="email"
              name="email"
              type="text"
              defaultValue={email}
              readOnly
            />
        </Form.Group>}
        <Form.Group className="mb-3">
          <Form.Label id="otp" htmlFor="otp">
            Enter OTP
          </Form.Label>
          <Form.OTP
            length={otpLength}
            shouldAutoFocus
            onChange={(v) => {
              setOtpValue(v);
              setErrMsg(false);
            }}
            className="test-otp-class"
          />
          {errMsg && <Form.Message type="error">{errMsg}</Form.Message>}
        </Form.Group>
        <Row className='d-flex justify-content-between'>
          <Col>
          <Form.Group>
              <Form.Button
                type="button"
                variant='underlined'
                onClick={onBack}
              >
                Back
              </Form.Button>
            </Form.Group>
          </Col>
        <Col className='text-right'>
          {resendOtp && (
              <div>
                {!disableResend && <Form.Button
                  variant='underlined'
                  type='button'
                  className="text-bottom-line p-0"
                  onClick={() => {
                    resendOtp();
                    setErrMsg(false);
                  }}
                  style={{ height: "fit-content" }}
                  disabled={disableResend}
                >
                  Resend OTP
                </Form.Button>}
                {retryTime && (
                  <Timer interval={retryTime} onComplete={onTimerComplete} />
                )}
              </div>
          )}
         </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Button
                type="button"
                className="rounded-btn w-100"
                onClick={() => handleVerifyOTP(otpValue)}
                disabled={disableVerifyBtn}
              >
                Verify OTP
              </Form.Button>
            </Form.Group>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default VerifyOTP;